import React from 'react';
import Notfound404 from "../components/Notfound404";

const UserLoginRoute = ({ children }) => {
    

    // const localStorageToken_ = localStorage.getItem("Token_");
    const Token_storage = localStorage.getItem("Token");
    // const Token_ = JSON.parse(Token_storage);

    // const result = localStorage.getItem("result");
    // const Token_re = JSON.parse(JSON.stringify(result));

    // console.log("Token: " + Token_storage)
    // console.log("Token1: " + Token_re)

    return  Token_storage !== null ? (

        <>
            {children}
        </>
    ) : (
        <Notfound404 text="No login" />
    )
}

export default UserLoginRoute
